import React, { useEffect, useState } from 'react';
const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    image: 'https://cdn.magicpatterns.com/uploads/gdLbLEhbEgwwwKfGXruLVv/DSC00807.jpg',
    alt: 'Ayevbosa and Abiodun in traditional attire'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8ojujGKkWCeyn6idCj3qJh/background.png',
    alt: 'Ayevbosa and Abiodun together'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section id="home" className="relative h-screen flex items-center justify-center bg-champagne bg-opacity-30 overflow-hidden" data-id="element-89">
      {/* Sliding background images */}
      {slides.map((slide, index) => <div key={index} className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} style={{
      backgroundImage: `url(${slide.image})`
    }} data-id="element-90" />)}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/60" data-id="element-91"></div>

      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto fade-in" data-id="element-92">
        <p className="font-sans text-sm md:text-base uppercase tracking-widest mb-4 text-white" data-id="element-93">
          We're getting married
        </p>
        <h1 className="font-serif text-5xl md:text-7xl mb-6 text-white leading-tight" data-id="element-94">
          Ayevbosa <span className="inline-block mx-2 text-gold" data-id="element-95">&</span>{' '}
          Abiodun
        </h1>
        <div className="w-24 h-0.5 bg-gold mx-auto my-8" data-id="element-96"></div>
        <p className="font-sans text-xl md:text-2xl mb-6 text-white" data-id="element-97">
          February 14, 2026 • Lagos State
        </p>
        <a href="#rsvp" className="inline-block mt-6 px-8 py-3 bg-gold text-white font-sans text-sm uppercase tracking-wider hover:bg-opacity-90 transition-all duration-300" data-id="element-98">
          RSVP
        </a>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 z-20" data-id="element-99">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentSlide ? 'bg-gold w-8' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-100" />)}
      </div>
    </section>;
};
export default Hero;